import styled from 'styled-components'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { colors } from 'Styled/variables'

export const RatingWrapper = styled.div`
  display: flex;
  width: fit-content;
  margin-bottom: 16px;
  text-align: left;
`

export const Title = styled.div`
  font-size: 10px;
  color: ${colors.mainText};
  line-height: 15px;
  text-align: left;
`

export const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};
  text-align: left;
`

export const StyledButton = styled(GreenBtn)`
  > img {
    margin-right: 0.625rem;
    width: 1rem;
    height: 1rem;
  }
`
